const Footer = ({ data }) => (
  <footer className="container pt6 tc lh-copy josefin-sans mid-gray">
    <Logo />
    <Dates />
    <Credits />
    <Socials socials={data.socials} />
    <Contact />
    <Sponsors sponsors={data.sponsors} mediaSponsors={data.mediaSponsors} />
    <Copyright />
  </footer>
)

export default Footer

/*
 *
 * General
 *
 */

import React, { Fragment } from 'react'
import HyperLink from '../components/base/HyperLink'

/*
 *
 * Logo
 *
 */

import Waypoint from 'react-waypoint'

import pinkLogo from '../svgs/logo-pink.svg'

class Logo extends React.Component {
  state = { revealed: false }

  handleWaypointEnter = () => {
    if (!this.state.revealed) {
      this.setState({ revealed: true })
    }
  }

  render() {
    const { revealed } = this.state

    return (
      <Fragment>
        <h1 className="sr-only">Pomegranate Opera</h1>
        <Waypoint
          ref={el => (this.logo = el)}
          onEnter={this.handleWaypointEnter}
          topOffset="150%"
          bottomOffset="150%"
        >
          <figure className="ml-auto mr-auto mb4 pb3 mw5">
            {revealed && (
              <img
                src={pinkLogo}
                alt="Pink logo showing a pomegranate behind the words 'Pomegranate Opera'."
                style={{ backgroundColor: `transparent` }}
              />
            )}
          </figure>
        </Waypoint>
      </Fragment>
    )
  }
}

/*
 *
 * Dates
 *
 */

const Dates = () => (
  <Fragment>
    <h3 className="f5 ttu pink">June 5-9, 2019 Premiere</h3>
    <p>Buddies in Bad Times Theatre</p>
    <HyperLink
      href="http://buddiesinbadtimes.com/show/pomegranate/"
      className="link-pink dib mb4"
    >
      Buy Tickets
    </HyperLink>
  </Fragment>
)

/*
 *
 * Credits
 *
 */

const Credits = () => (
  <Fragment>
    <h3 className="f5 ttu pink">Words & Music by</h3>
    <p className="mb4">Amanda Hale & Kye Marshall</p>
  </Fragment>
)

/*
 *
 * Social Links
 *
 */

import FaFacebook from 'react-icons/lib/fa/facebook'
import FaTwitter from 'react-icons/lib/fa/twitter'
import FaInstagram from 'react-icons/lib/fa/instagram'
import FaYouTube from 'react-icons/lib/fa/youtube'
import FaWordPress from 'react-icons/lib/fa/wordpress'
import shortid from 'shortid'

const Socials = ({ socials }) => (
  <Fragment>
    <h3 className="f5 ttu pink">Follow us</h3>
    <nav aria-label="Social media links" className="mb4">
      <ul className="flex justify-center">
        {socials.map(social => {
          let Icon
          social.site === `Facebook` && (Icon = FaFacebook)
          social.site === `Twitter` && (Icon = FaTwitter)
          social.site === `Instagram` && (Icon = FaInstagram)
          social.site === `YouTube` && (Icon = FaYouTube)
          social.site === `WordPress` && (Icon = FaWordPress)

          return (
            <li key={shortid.generate()} className="">
              <HyperLink href={social.link} className="link db f4 ph2">
                <span className="sr-only">Follow us on {social.site}</span>
                <Icon aria-hidden="true" />
              </HyperLink>
            </li>
          )
        })}
      </ul>
    </nav>
  </Fragment>
)

/*
 *
 * Contact
 *
 */

const Contact = () => (
  <Fragment>
    <h3 className="f5 ttu pink">Contact</h3>
    <h4 className="f5 fw6">Media &amp; Press Inquiries</h4>
    <HyperLink href="mailto:pomegranateopera@gmail.com" className="link-pink">
      pomegranateopera@gmail.com
    </HyperLink>
  </Fragment>
)

/*
 *
 * Sponsors
 *
 */

import Img from '../components/base/Img'
import BuddiesSVG from '../svgs/logo-buddies.svg'

function Sponsors({ sponsors, mediaSponsors }) {
  return (
    <React.Fragment>
      <style
        dangerouslySetInnerHTML={{
          __html: `
      .sponsor-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
        align-items: center;
        margin: 0 auto;
        max-width: 70rem;
      }
    `
        }}
      />

      <ul className="sponsor-grid">
        <li>
          <img
            src={BuddiesSVG}
            alt="Logo for Buddies in Bad Times Theatre"
            className="db ml-auto mr-auto mt5 w-two-thirds mw5"
          />
        </li>

        {sponsors.map((sponsor, i) => (
          <li key={i} className="w-100">
            <HyperLink
              href={sponsor.link}
              className="db ml-auto mr-auto mt5 w-two-thirds mw5"
            >
              <Img
                sizes={sponsor.image.childImageSharp.sizes}
                alt={sponsor.alt}
                critical={true}
              />
            </HyperLink>
          </li>
        ))}

        {mediaSponsors.map((sponsor, i) => (
          <li key={i}>
            <HyperLink
              href={sponsor.link}
              className="db ml-auto mr-auto mt5 w-two-thirds mw5"
            >
              <Img
                sizes={sponsor.image.childImageSharp.sizes}
                alt={sponsor.alt}
                critical={true}
              />
            </HyperLink>
          </li>
        ))}
      </ul>
    </React.Fragment>
  )
}

/*
 *
 * Copyright
 *
 */

const Copyright = () => (
  <p className="mt3 pa3 lh-copy f6">
    &copy; {new Date().getFullYear()} Pomegranate Opera. Brewed&nbsp;by&nbsp;
    <HyperLink href="http://coffeeshopcreative.ca" className="link-pink">
      Coffeeshop&nbsp;Creative
    </HyperLink>
    .
  </p>
)



// WEBPACK FOOTER //
// ./src/sections/Footer.js